import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface SeguimientoQuejaPayload {
  id_queja: number;
  fecha_seguimiento: string; // formato YYYY-MM-DD
  observacion: string;
  avance: number;
  estado?: number;
}

export interface SeguimientoQueja {
  id?: number;
  id_queja: number;
  fecha_seguimiento: string;
  observacion: string;
  avance: number;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
  // Queja asociada incluida por el backend (association: "QuejaData")
  QuejaData?: {
    [key: string]: any;
  };
}

@Injectable({ providedIn: "root" })
export class SeguimientoQuejasService {
  private readonly baseUrl = `${environment.apiUrl}/api/seguimiento_quejas`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get(this.baseUrl, { withCredentials: true });
  }

  getByQueja(idQueja: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/queja/${idQueja}`, { withCredentials: true });
  }

  getById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${id}`, { withCredentials: true });
  }

  create(payload: SeguimientoQuejaPayload): Observable<any> {
    return this.http.post(this.baseUrl, payload, { withCredentials: true });
  }

  update(id: number, payload: Partial<SeguimientoQuejaPayload>): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, payload, { withCredentials: true });
  }

  inactivar(id: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  activar(id: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}